import { Component, OnInit, ViewChild, TemplateRef } from '@angular/core';
import {MatPaginator as MatPaginator } from '@angular/material/paginator';
import {MatTableDataSource as MatTableDataSource } from '@angular/material/table';
import { BsModalService, BsModalRef } from 'ngx-bootstrap/modal';
import { AuthService } from 'src/app/services/auth.service';
import {MatSnackBar as MatSnackBar } from '@angular/material/snack-bar';
import { HttpClient } from '@angular/common/http';
import { SnotifyService, SnotifyPosition, ToastDefaults } from 'ng-snotify';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-release-manager',
  templateUrl: './release-manager.component.html',
  styleUrls: ['./release-manager.component.css']
})
export class ReleaseManagerComponent implements OnInit {

  displayedColumns: string[] = ['id', 'createdBy', 'creationDate', 'componentType', 'fileName', 'description'];
  @ViewChild(MatPaginator,{static:true}) paginator: MatPaginator;

  dataSource = new MatTableDataSource<any>([]);

  modalRef: BsModalRef;
  release: any = { Enviroment: '2' };
  formData: FormData = new FormData;
  user: any;

  constructor(private modalService: BsModalService, private authService: AuthService, private snotifyService: ToastrService, private httpClient: HttpClient) {
    
   }

  ngOnInit() {
    this.user = this.authService.getLoggedUser()
    this.getAllVersions()
  }

  getAllVersions() {

    this.httpClient.get('/general/GetAllVersion').subscribe((res: any) => {
      this.dataSource = new MatTableDataSource<any>(res);
      this.dataSource.paginator = this.paginator;

    });

  }

  // openSnackBar(message: string) {
  //   this._snackBar.open(message, '', {
  //     duration: 2000,
  //   });
  // }
  openNotifySuccess(message: string) {
    this.snotifyService.success("", message, {
      timeOut: 2000,
      progressBar: true,
      tapToDismiss: true,
    });
  }

  openNotifyError(message: string) {
    this.snotifyService.error(message, "Something went wrong!!", {
    timeOut: 2000,
      progressBar: true,
      tapToDismiss: true,
    });
  }
  newRelease(template: TemplateRef<any>) {
    this.modalRef = this.modalService.show(template, { backdrop: true, ignoreBackdropClick: true });
  }

  addRelease(form) {
    if (form.invalid)
      return

    if (this.formData.get('file') == null) {
      this.openNotifySuccess("Please select Release File !")
      return
    }

    this.formData.append("FileName", this.formData.get('file')['name']);

    this.formData.append("Description", this.release.notes || '');

    this.formData.append("ComponentType", this.release.Enviroment);

    this.httpClient.post('/general/TransferCMSFiles/', this.formData).subscribe((res: any) => {

      this.openNotifySuccess("Release added")
      this.formData = new FormData();
      this.release = { Enviroment: '2' };
      this.modalRef.hide()
      this.getAllVersions()
    });


  }

  onFilesAdded(event, drop) {
    this.formData = new FormData();
    for (var i = 0; i < event.addedFiles.length; i++) {
      this.formData.append("file", event.addedFiles[i]);
    }
  }

  reset(drop) {
    drop.reset();
    this.formData = new FormData()
  }


  applyFilter(filterValue: string) {

    this.dataSource.filter = filterValue.trim().toLowerCase();

    if (this.dataSource.paginator) {
      this.dataSource.paginator.firstPage();
    }
  }

}




